<template>
  <div class="animated fadeIn wrap">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <form @submit="ValidarForm">
            <header class="card-header">
              <div class="d-flex">
                <strong class="align-self-center">{{
                  $t("sectionRelatorio.relatorioFiltroTitle")
                }}</strong>
              </div>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <small>{{ $t("textObrigatorios") }}</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>{{
                      $t("sectionRelatorio.relatorioTipo")
                    }}</label>
                    <select v-model="filtro.tipo" class="form-control">
                      <option selected value>{{ $t("textSelecione") }}</option>
                      <option value="1">WhatsApp</option>
                      <option value="2">Facebook</option>
                      <option value="3">E-mail</option>
                      <option value="4">Instagram</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>{{
                      $t("sectionRelatorio.relatorioStatus")
                    }}</label>
                    <select v-model="filtro.status" class="form-control">
                      <option selected value>{{ $t("textSelecione") }}</option>
                      <option value="1">{{ $t("textEmAtendimento") }}</option>
                      <option value="2">{{ $t("textCancelado") }}</option>
                      <option value="3">{{ $t("textConcluido") }}</option>
                    </select>
                  </div>
                </div>
                <div
                  class="col-sm-12 col-md-6 col-lg-5 col-xl-4"
                  title="Selecione um ou mais usuários"
                >
                  <div class="form-group">
                    <label for>{{
                      $t("sectionRelatorio.relatorioUsuario")
                    }}</label>
                    <v-select
                      v-model="filtro.usuarios"
                      :placeholder="$t('textSelecione')"
                      :options="usuarioOptions"
                      multiple
                    >
                      <template slot="no-options">
                        {{ $t("textNenhumResultado") }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>{{
                      $t("sectionRelatorio.relatorioDataInicio")
                    }}</label>
                    <input
                      v-model="filtro.dataInicio"
                      type="date"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>{{
                      $t("sectionRelatorio.relatorioDataFim")
                    }}</label>
                    <input
                      v-model="filtro.dataFim"
                      type="date"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>{{
                      $t("sectionRelatorio.relatorioDataInicioFechamento")
                    }}</label>
                    <input
                      v-model="filtro.dataInicioFechamento"
                      type="date"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>{{
                      $t("sectionRelatorio.relatorioDataFimFechamento")
                    }}</label>
                    <input
                      v-model="filtro.dataFimFechamento"
                      type="date"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4">
                <div class="form-group">
                  <label for>{{ $t("sectionMotivo.motivo") }}</label>
                  <v-select v-model="filtro.motivos" :placeholder="$t('sectionMotivo.selecione')"
                    :options="motivosOptions" @search:focus="getMotivosSelect2" multiple>
                    <template slot="no-options">
                      {{ $t("sectionAttendance.pleaseWaitNoResultsForYourSearch") }}
                    </template>
                  </v-select>
                </div>
              </div>
              <div
                class="col-sm-12 col-md-3 col-lg-2 col-xl-2">
                <div class="form-group">
                  <label for>{{ $t("sectionMotivo.possuiComentario") }}</label>
                  <b-form-checkbox v-model="filtro.possuiComentario" name="check-button" switch>
                    {{ $t("textYes") }}
                  </b-form-checkbox>
                  
                </div>
              </div>
              </div>
              <div class="row no-print">
                <div class="col-sm-12">
                  <div class="form-group">
                    <button class="btn btn-primary mr-2" type="submit">
                      {{ $t("btFiltrar") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div v-if="loading" class="loading-container">
            <RotateSquare
              class="loading-position animated fadeIn"
              size="60px"
            ></RotateSquare>
          </div>
          <div v-else class="card-body">
            <h5>
              {{
                $t(
                  "sectionRelatorio.relatorioTitleAtendimentoTempoMedioPeriodo"
                )
              }}
            </h5>

            <b-table
              :hover="true"
              responsive
              :items="itensPeriodo"
              :fields="fieldsPeriodo"
              striped
              show-empty
              :empty-text="$t('textNadaEncontrado')"
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:cell(tempo)="data">
                <div v-if="data.item.tempo" class="center">
                  <label for>{{ ObterDataFormatada(data.item.tempo) }}</label>
                </div>
              </template>
            </b-table>

            <h5>
              {{
                $t(
                  "sectionRelatorio.relatorioTitleAtendimentoTempoMedioAtendente"
                )
              }}
            </h5>
            <b-table
              :hover="true"
              responsive
              :items="itensMedia"
              :fields="fieldsMedia"
              striped
              show-empty
              :empty-text="$t('textNadaEncontrado')"
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:cell(tempo)="data">
                <div v-if="data.item.tempo" class="center">
                  <label for>{{ ObterDataFormatada(data.item.tempo) }}</label>
                </div>
              </template>
            </b-table>

            <h5>
              {{
                $t(
                  "sectionMotivo.relMotivos"
                )
              }}
            </h5>
            <b-table
              :hover="true"
              responsive
              :items="itensMotivos"
              :fields="fieldsMotivos"
              striped
              show-empty
              :empty-text="$t('textNadaEncontrado')"
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:cell(tempo)="data">
                <div v-if="data.item.tempo" class="center">
                  <label for>{{ ObterDataFormatada(data.item.tempo) }}</label>
                </div>
              </template>
            </b-table>
              <div class="d-flex">
                <h5>{{ $t("sectionRelatorio.relatorioTitleAtendimentoGeral") }}</h5>
                  <h3 class="ml-auto" v-if="itensGeral.length > 0">
                      <a href="#" class="no-print" @click="DownloadCsv" :disabled="loading">Download CSV</a>
                  </h3>
              </div>
            <b-table
              :hover="true"
              responsive
              :items="itensGeral"
              :fields="fieldsGeral"
              striped
              show-empty
              :empty-text="$t('textNadaEncontrado')"
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:cell(tipo)="data">
                <div class="center">
                  <label for>{{ ObterTipoNome(data.item.tipo) }}</label>
                </div>
              </template>
              <template v-slot:cell(status)="data">
                <div class="center">
                  <label for>{{ ObterStatusNome(data.item.status) }}</label>
                </div>
              </template>
              <template v-slot:cell(dataAbertura)="data">
                <div class="center">
                  <label for>{{
                    new Date(data.item.dataAbertura).toLocaleString() 
                  }}</label>
                </div>
              </template>
              <template v-slot:cell(dataFechamento)="data">
                <div class="center">
                  <label v-if="data.item.dataFechamento" for>{{
                    new Date(data.item.dataFechamento).toLocaleString()
                  }}</label>
                </div>
              </template>
              <template v-slot:cell(motivoComentario)="data">
                  <span :title=data.item.motivoComentario>{{truncateText(data.item.motivoComentario)}}</span>
              </template>
              <template v-slot:cell(tempo)="data">
                <div v-if="data.item.tempo" class="center">
                  <label for>{{ ObterDataFormatada(data.item.tempo) }}</label>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import StatusAtendimento from "../../enums/StatusAtendimento";
import TipoAtendimento from "../../enums/TipoAtendimento";

export default {
  name: "RelatorioAtendimento",
  components: { RotateSquare },
  data() {
    return {
      locale: this.$i18n.locale,
      filtro: {
        dataFim: "",
        dataInicio: "",
        dataFimFechamento: "",
        dataInicioFechamento: "",
        usuarios: [],
        status: "",
        tipo: "",
        motivos: null,
        possuiComentario:false
      },
      loading: false,
      usuarioOptions: [],
      itensPeriodo: [],
      itensMedia: [],
      itensGeral: [],
      itensMotivos: [],
      motivosOptions:[],
    };
  },
  computed: {
    fieldsGeral() {
      return [
        {
          key: "usuario",
          label: this.$t("sectionOrcamento.orcamentoNome"),
          sortable: true
        },
        {
          key: "identificador",
          label: this.$t("sectionOrcamento.orcamentoIdentificador"),
          sortable: true
        },
        {
          key: "tipo",
          label: this.$t("sectionMidia.midiaTipo"),
          sortable: true
        },
        {
          key: "status",
          label: this.$t("sectionRelatorio.relatorioStatus"),
          sortable: true
        },
        {
          key: "dataAbertura",
          label: this.$t("sectionRelatorio.relatorioDataAbertura"),
          sortable: true
        },
        {
          key: "dataFechamento",
          label: this.$t("sectionRelatorio.relatorioDataFechamento"),
          sortable: true
        },
        {
          key: "tempo",
          label: this.$t("sectionRelatorio.atendimentoLabelTempo"),
          sortable: true
        },
        {
          key: "motivos",
          label: this.$t("sectionMotivo.motivo"),
          sortable: true
        },
        {
          key: "motivoComentario",
          label: this.$t("sectionMotivo.comentario"),
          sortable: true
        }
      ];
    },
    fieldsPeriodo() {
      return [
        {
          key: "tempo",
          label: this.$t("sectionRelatorio.atendimentoLabelTempo"),
          sortable: true
        },
        { key: "totalCancelado", label: "Cancelados", sortable: true },
        { key: "totalConcluido", label: "Concluídos", sortable: true },
        {
          key: "totalEmAtendimento",
          label: this.$t("textEmAtendimento"),
          sortable: true
        },
        { key: "total", label: "Total", sortable: true }
      ];
    },
    fieldsMedia() {
      return [
        { key: "usuario", label: "Nome", sortable: true },
        { key: "tempo", label: "Tempo", sortable: true },
        { key: "totalCancelado", label: "Cancelados", sortable: true },
        { key: "totalConcluido", label: "Concluídos", sortable: true },
        {
          key: "totalEmAtendimento",
          label: this.$t("textEmAtendimento"),
          sortable: true
        },
        { key: "total", label: "Total", sortable: true }
      ];
    },
    fieldsMotivos() {
      return [
        { key: "motivo", label: "Motivo", sortable: true },
        { key: "tempo", label: "Tempo", sortable: true },
        { key: "quantidade", label: "Quantidade", sortable: true },
        { key: "comentario", label: "N° de comentarios", sortable: true },
      ];
    }
  },
  watch: {
    locale(val) {
      this.$i18n.locale = val;
    }
  },
  mounted() {
    this.ObterUsuarioSelect2();
  },
  created() {},
  methods: {
    getMotivosSelect2() {
      this.$http({
        url:
          "/motivos/obter-select2/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "GET"
      })
        .then((response) => {
          this.motivosOptions = response.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    truncateText(text) {
      if (typeof text === 'string' && text.length > 20) {
          return text.substring(0, 20) + '...';
      } else {
          return text;
      }
    },
    ValidarForm(evt) {
      evt.preventDefault();
      this.ObterGrid();
    },
    ObterDataFormatada(lista) {
      let formato = "";
      if (lista[0] > 0) formato += lista[0] + "d ";
      if (lista[1] > 0) formato += lista[1] + "h ";
      if (lista[2] > 0) formato += lista[2] + "m ";
      if (lista[3] > 0) formato += lista[3] + "s ";
      return formato;
    },
    ObterUsuarioSelect2() {
      this.loading = true;
      this.$http({
        url:
          "/usuario/obter-select2/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "GET"
      })
        .then((response) => {
          this.loading = false;
          this.usuarioOptions = response.data;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    ObterStatusNome(status) {
      switch (status) {
        case StatusAtendimento.EmAtendimento:
          return this.$t("textEmAtendimento");
        case StatusAtendimento.Cancelado:
          return this.$t("textCancelado");
        case StatusAtendimento.Concluido:
          return this.$t("textConcluido");
        default:
          return this.$t("textNenhum");
      }
    },
    ObterTipoNome(tipo) {
      switch (tipo) {
        case TipoAtendimento.WhatsApp:
          return "WhatsApp";
        case TipoAtendimento.Facebook:
          return "Facebook";
        case TipoAtendimento.Email:
          return "E-mail";
          case TipoAtendimento.Instagram:
          return "Instagram";
        default:
          return "";
      }
    },
    ObterGrid() {
      this.loading = true;
      this.$http({
        url: "/relatorio/atendimento",
        data: this.filtro,
        method: "POST"
      })
        .then((response) => {
          this.itensGeral = response.data.geral || [];
          this.itensMedia = response.data.media || [];
          this.itensMotivos = response.data.motivos || [];
          if (response.data.periodo)
            this.itensPeriodo = [response.data.periodo];
          else this.itensPeriodo = [];
          this.loading = false;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    DownloadCsv(){
        this.$http({url: "relatorio/atendimento-geral-csv",data: this.filtro, method: 'POST', responseType: 'blob', })
            .then(response => {

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download','relatorio.csv')
            document.body.appendChild(link)
            link.click()


        })
        .catch(err => {
            alert(err.message)
        })
    }
  }
};
</script>
